<template>
<div> 
  <div v-if="instrumentType != ''" class="result lighten-1 py-3" style ="display:flex;top:100%; right:0;left:0;height:74px;justify-content:center;">
    <span style="font-size: 10px;font-weight: bold;" v-if="selectedInstrumentType != ''">Estimated Power Module life for {{selectedInstrumentType}}</span> 
  </div>

  <v-expansion-panels focusable>
     <!--PRODUCT GROUP -->
    <v-expansion-panel>
      <v-expansion-panel-header v-bind:style="ProductActiveBorder()">PRODUCT GROUP <br><br> {{selectedProductCategory}}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="form-columns">
          <label for="updateRate">PRODUCT GROUP: </label>
         <v-select
          id="productCategory"
          v-model="productCategory"
          :items="products"
          :label="productCategory ? '':'Select'"
          item-value="id"
          filled
          @change="reset()"
        >
         <template v-slot:selection="{ item }">
             <span >{{ item.product_name }}</span>
          </template>
          <template  v-slot:item="{ item }">
             <span style="width:100%" @click ="selectedProductCategory = item.product_name">{{ item.product_name }}</span>
          </template>
        </v-select>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!--INSTRUMENT TYPE-->
    <v-expansion-panel :disabled="productCategory == ''">
      <v-expansion-panel-header v-bind:style="InstrumentTypeActiveBorder()">INSTRUMENT TYPE <br> <br> {{selectedInstrumentType}}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="form-columns">
         <v-select
          id="instrumentType"
          v-model="instrumentType"
          :items="instrumentTypes"
          :label="instrumentType ? '':'Select'"
          item-value="id"
          filled
          @change="getPowerTypes(instrumentType)"
        >
         <template v-slot:selection="{ item }">
             <span class="mt-4" >{{ item.product_name }}</span>
          </template>
          <template  v-slot:item="{ item }">
             <span @click="selectedInstrumentType = item.product_name" style="width:100%;text-align:left">{{ item.product_name }}</span>
          </template>
        </v-select>
      </div>
      </v-expansion-panel-content>
    </v-expansion-panel>

   <!--UPDATE RATE-->
    <v-expansion-panel :disabled="instrumentType == ''"  v-show="ambientTemperatureType != 3">
      <v-expansion-panel-header v-bind:style="UpdateRateActiveBorder()">UPDATE RATE <br> <br> {{selectedUpdateRate}}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="form-columns">
        <v-select
          id="updateRate"
          v-model="updateRate"
          :items="updateRates"
          item-value="id"
          :label="updateRate ? '':'Select'"
          @change="getOperatingConditions()"
          filled
        >
          <template v-slot:selection="{ item }">
             <span class="mt-4" >{{ item.upateRateLabel }}</span>
          </template>
          <template  v-slot:item="{ item }">
             <span @click="selectedUpdateRate = item.upateRateLabel" style="width:100%;text-align:left">{{ item.upateRateLabel }}</span>
          </template>
        </v-select>
      </div>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!--ACQUISITION RATE-->
    <v-expansion-panel :disabled="instrumentType == ''" v-show="ambientTemperatureType == 3">
      <v-expansion-panel-header v-bind:style="AxquisitionRateActiveBorder()">ACQUISITION RATE <br> <br> {{selectedAcqusitionRateLabel}}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="form-columns">
        <v-select
          id="updateRate"
          v-model="acqusitionRate"
          :items="acqusitionRates"
          item-value="id"
          :label="acqusitionRate ? '':'Select'"
          @change="getOperatingConditions()"
          filled
        >
          <template v-slot:selection="{ item }">
             <span class="mt-4" >{{ item.acqusitionRateLabel }}</span>
          </template>
          <template  v-slot:item="{ item }">
             <span @click="selectedAcqusitionRateLabel = item.acqusitionRateLabel" style="width:100%;text-align:left">{{ item.acqusitionRateLabel }}</span>
          </template>
        </v-select>
      </div>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!--POWER TYPE-->
    <v-expansion-panel :disabled="instrumentType == ''">
      <v-expansion-panel-header v-bind:style="PowerTypeActiveBorder()">POWER TYPE <br> <br> {{selectedPowerType}}</v-expansion-panel-header>
      <v-expansion-panel-content>
         <div class="form-columns">
        <v-select
          v-model="powerType"
          :items="instrumentTypePowerTypes"
          item-value="id"
          filled
          :label="powerType ? '':'Select'"
          @change="getAmbientTemperatures()"
        >
          <template v-slot:selection="{ item }">
             <span class="mt-4" >{{ item.label }}</span>
          </template>
          <template  v-slot:item="{ item }">
             <span @click="selectedPowerType = item.label" style="width:100%;text-align:left">{{ item.label }}</span>
          </template>
        </v-select>
      </div>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!--NETWORK TOPOLOGY-->
    <v-expansion-panel :disabled="powerType == ''">
      <v-expansion-panel-header v-bind:style="OperatingTemperatureActiveBorder()">
        <div  style="display:grid">
          <div style="display:flex;margin-bottom:10px">
            <span> NETWORK TOPOLOGY </span>
             <!-- Operation Conditions Help Dialog Box -->
               <v-dialog transition="dialog-bottom-transition">
                    <template v-slot:activator="{ on, attrs }">
                                <!-- <v-icon  v-bind="attrs" v-on="on"  style="font-size:10px;border:1px solid;border-radius: 100px;width:10px">mdi-help</v-icon>  -->
                                <div v-bind="attrs" v-on="on" style="border:1px solid;border-radius:50px;text-align:center;height:15px;width:15px;font-size:10px;font-weight:bold;margin-left:5px">?</div>
                    </template>
                    <template v-slot:default="dialog">
                          <v-card>
                              <v-toolbar
                                dark
                                color="white"
                                style="color:black;font-weight:bold;"
                              >NETWORK TOPOLOGY</v-toolbar>
                              <v-card-text style="display:grid;overflow:hidden;color:black;font-weight:bold;text-align: left;justify-content: center;padding-top:20px;">
                                <div style="border-bottom:1px solid;text-align:center" >
                                  <span>Well-Formed Network</span><br><br>
                                  <img height="150px" style="margin-bottom:15px" src="../assets/images/OperatingConditions/Well Formed Network.png" />
                                </div>  
                                <div style="border-bottom:1px solid; solid;text-align:center">
                                  <span>Pinch Point Network</span><br><br>
                                  <img  height="150px" style="margin-bottom:15px" src="../assets/images/OperatingConditions/Pinch Point Network.png" />
                                </div>  
                                <div style="border-bottom:1px solid;text-align:center" >
                                  <span>Point to Point Network </span><br><br>
                                  <img height="100px" width="330px" src="../assets/images/OperatingConditions/Point to Point Network.png" />
                                </div>  
                              </v-card-text>
                              <v-card-actions class="justify-end">
                                  <v-btn class="bottom-btn" color="#00AA7E" width="200px" height="40px" style="color:white;border-radius:0;font-weight:600;font-size:12px" @click="dialog.value = false">EXIT </v-btn>
                              </v-card-actions>
                       </v-card>
                  </template>
                </v-dialog> 
          </div>
          <div>{{selectedOperatingCondition}}</div>
       </div>
 
                      
        
        </v-expansion-panel-header>
      <v-expansion-panel-content>
         <div class="form-columns">
        <v-select
          v-model="operatingCondition"
          :items="operatingConditions"
          item-value="id"
          :label="operatingCondition ? '':'Select'"
           filled
           @change="getOperatingConditionValue()"
        >
          <template v-slot:selection="{ item }">
             <span class="mt-4" >{{ item.label }}</span>
          </template>
          <template  v-slot:item="{ item }">
             <span @click="selectedOperatingCondition = item.label" style="width:100%;text-align:left">{{ item.label }}</span>
          </template>
        </v-select>
      </div>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- AMBIENT TEMPERATURE -->
    <v-expansion-panel :disabled="updateRate == '' && acqusitionRate =='' " >
      <v-expansion-panel-header v-bind:style="AmbientTemperatureActiveBorder()">
        <div  style="display:grid">
          <div style="display:flex;margin-bottom:10px">
              <span> AVERAGE AMBIENT TEMPERATURE </span>
              <v-dialog transition="dialog-bottom-transition">
                    <template v-slot:activator="{ on, attrs }">
                                <!-- <v-icon  v-bind="attrs" v-on="on"  style="font-size:10px;border:1px solid;border-radius: 100px;width:10px">mdi-help</v-icon>  -->
                                <div v-bind="attrs" v-on="on" style="border:1px solid;border-radius:50px;text-align:center;height:15px;width:15px;font-size:10px;font-weight:bold;margin-left:5px">?</div>
                    </template>
                    <template v-slot:default="dialog">
                          <v-card>
                              <v-toolbar
                                dark
                                color="white"
                                style="color:black;font-weight:bold;"
                              >AVERAGE AMBIENT TEMPERATURE</v-toolbar>
                              <v-card-text style="display:grid;overflow:hidden;color:black;font-weight:bold;text-align: left;justify-content: center;padding-top:20px;">
                                 In typical applications, the ambient temperature will fluctuate due to daily and seasonal temperature changes. The estimation tool assumes a consistent ambient temperature to calculate battery leakage current and internal resistance. As the power module ages, the battery internal resistance will increase at low temperatures leading to lower voltage output under load. It is recommended to replace power modules nearing their end of life prior to the onset of sustained low ambient temperatures.
                              </v-card-text>
                              <v-card-actions class="justify-end">
                                  <v-btn class="bottom-btn" color="#00AA7E" width="200px" height="40px" style="color:white;border-radius:0;font-weight:600;font-size:12px" @click="dialog.value = false">EXIT </v-btn>
                              </v-card-actions>
                       </v-card>
                  </template>
                </v-dialog> 
          </div>
           <div>{{selectedAmbientTemperatures}}</div>
        </div>
     
        
        </v-expansion-panel-header>
      <v-expansion-panel-content>
         <div class="form-columns">
        <v-select
          v-model="ambientTemperature"
          :items="ambientTemperatures"
          item-value="value"
          :label="operatingCondition ? '':'Select'"
          @change="getResult()"
        >
          <template v-slot:selection="{ item }">
             <span class="mt-4" >{{ item.label }}</span>
          </template>
          <template  v-slot:item="{ item }">
             <span @click="selectedAmbientTemperatures = item.label" style="width:100%;text-align:left">{{ item.label }}</span>
          </template>
        </v-select>
      </div>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel :disabled="result == 0">
      <v-expansion-panel-header  v-bind:style="ResultActiveBorder()">ESTIMATED POWER MODULE LIFE RESULT </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="form-columns">
            <div style="background-color:#F0F0F0;justify-content: center;text-align: center;" class="pt-5 pb-5" >
                <v-row class="mb-10" no-gutters >
                    <v-col sm="12" md="12">
                     <span style="font-size:25px">ESTIMATED POWER MODULE LIFE</span> 
                    </v-col>
                </v-row>
                <v-row class="mb-12" no-gutters>
                    <v-col sm="12" md="12" >
                      <span style="font-size:80px">{{result}}</span> 
                    </v-col>
                </v-row>
                <v-row class="mb-1" no-gutters>
                    <v-col sm="12" md="12">
                      <span style="font-size:25px">YEARS</span> 
                    </v-col>
                </v-row>
             </div>
             <v-btn class="bottom-btn" color="#00AA7E" width="100%" height="40px" style="color:white;border-radius:0;font-weight:600;font-size:12px" @click="viewProduct()">VIEW PRODUCT > </v-btn>
        </div>          
      </v-expansion-panel-content>
    </v-expansion-panel>

  </v-expansion-panels>
  </div>
</template>
<script>
import products from "../json/products.json"
import instrumentTypes from "../json/instrumentType.json"
import updateRates from "../json/updateRate.json"
import powerType from "../json/powerType.json"
import 'vue-simple-accordion/dist/vue-simple-accordion.css';
export default {
  name:"Mobile",
  computed:{

    products(){
      return products;
    },
    instrumentTypes(){
      var instrument_types = []
      for(var i = 0; i < instrumentTypes.length; i++){
        if(instrumentTypes[i].category_id == this.productCategory){
          instrument_types.push(instrumentTypes[i])       
        }
      }
      if(instrument_types.length != 0){
         return instrument_types;
      }else{
        instrument_types.push({"id":"0","category_id":"0","product_name":"NO DATA","url":"https://www.emerson.com/", "img":"rosemount-3051s-wireless-in-line-pressure-transmitter-facing-left"})
        return instrument_types
      }
    },


    powerTypes(){
      return powerType;
    },

  },
  data () {
      return {
        currentStep: 1,

        productCategory:"",
        instrumentType:"",

        selectedProductCategory:"",
        selectedInstrumentType:"",

        updateRate:"",
        selectedUpdateRate:"",
        
        operatingConditions:[],
        operatingCondition:"",
        operatingConditionValue:0,
        selectedOperatingCondition:"",

        instrumentTypePowerTypes:[],
        powerType:"",
        selectedPowerType:"",
        selectedAcqusitionRateLabel:"",

        updateRates:[],
        acqusitionRates:[],
        acqusitionRate:0,

        ambientTemperatures:[],
        ambientTemperature:0,
        selectedAmbientTemperatures:"",
        ambientTemperatureValue:0,

        ambientTemperatureType:"",
        powerModuleURL:"",
        result:0
      }
    },
  methods:{
    getOperatingConditions(){
      var index = this.updateRates.findIndex(x => x.id === this.updateRate);
      this.operatingConditions = this.updateRates[index].operratingConditions
      this.getOperatingConditionValue()
    },
    getOperatingConditionValue(){
      if(this.operatingCondition != 0){
        var index = this.operatingConditions.findIndex(x => x.id === this.operatingCondition);
        this.operatingConditionValue = this.operatingConditions[index].value
        this.getResult()
      }   
    },
    getPowerTypes(id){
       this.instrumentTypePowerTypes = []
       this.selectedPowerType = ""
       for(var i = 0; i < this.instrumentTypes.length; i++){
        if(this.instrumentTypes[i].id == id){
          this.ambientTemperatureType = this.instrumentTypes[i].ambientTemperatureType
            if(this.ambientTemperatureType == 0 ){
              this.getUpdateRates(id)
              for(var p = 0; p < this.instrumentTypes[i].powerType.length; p++)
              {
                var index = this.powerTypes.findIndex(x => x.id === this.instrumentTypes[i].powerType[p]);
                this.instrumentTypePowerTypes.push(this.powerTypes[index])
              }
            }else if(this.ambientTemperatureType == 1){
              this.getUpdateRates(id)
              for(var p = 0; p < this.instrumentTypes[i].powerType.length; p++)
                {
                  var index = this.powerTypes.findIndex(x => x.id === this.instrumentTypes[i].powerType[p]);
                  this.instrumentTypePowerTypes.push(this.powerTypes[index])
                }
            }else if(this.ambientTemperatureType == 2){
              this.getUpdateRates(id)
              for(var p = 0; p < this.instrumentTypes[i].powerType.length; p++)
                {
                  var index = this.powerTypes.findIndex(x => x.id === this.instrumentTypes[i].powerType[p]);
                  this.instrumentTypePowerTypes.push(this.powerTypes[index])
                }
            }else if(this.ambientTemperatureType == 3){
              this.getAcqusitionRates(id)
              for(var p = 0; p < this.instrumentTypes[i].powerType.length; p++)
                {
                  var index = this.powerTypes.findIndex(x => x.id === this.instrumentTypes[i].powerType[p]);
                  this.instrumentTypePowerTypes.push(this.powerTypes[index])
                }
            }
           
        }
      }
    },
    getUpdateRates(id){
      var instrument_index = instrumentTypes.findIndex(x => x.id === id)
      this.$store.state.view_product_result = instrumentTypes[instrument_index].url;
      this.updateRates = instrumentTypes[instrument_index].updateRates;
      if(this.updateRates.findIndex(x => x.upateRateLabel == "60 s") != -1){
        var default_index = this.updateRates.findIndex(x => x.upateRateLabel == "60 s")
        this.updateRate = this.updateRates[default_index].id
        this.selectedUpdateRate = this.updateRates[default_index].upateRateLabel
        this.getOperatingConditions()
      }else if(this.updateRates.findIndex(x => x.upateRateLabel == "1 min") != -1){
        var default_index = this.updateRates.findIndex(x => x.upateRateLabel == "1 min")
        this.updateRate = this.updateRates[default_index].id
        this.selectedUpdateRate = this.updateRates[default_index].upateRateLabel
        this.getOperatingConditions()
      }else if(this.updateRates.findIndex(x => x.upateRateLabel == "20 min") != -1){
        var default_index = this.updateRates.findIndex(x => x.upateRateLabel == "20 min")
        this.updateRate = this.updateRates[default_index].id
        this.selectedUpdateRate = this.updateRates[default_index].upateRateLabel
        this.getOperatingConditions()
      }
      else if(this.updateRates.findIndex(x => x.upateRateLabel == "300 s") != -1){
        var default_index = this.updateRates.findIndex(x => x.upateRateLabel == "300 s")
        this.updateRate = this.updateRates[default_index].id
        this.selectedUpdateRate = this.updateRates[default_index].upateRateLabel
        this.getOperatingConditions()
      }
      return instrumentTypes[instrument_index].updateRates;
    },
    getAcqusitionRates(id){
      var instrument_index = instrumentTypes.findIndex(x => x.id === id)
      
      this.$store.state.view_product_result = instrumentTypes[instrument_index].url;
      this.acqusitionRates = instrumentTypes[instrument_index].AcqusitionRate;
      
      if(this.acqusitionRates.findIndex(x => x.acqusitionRateLabel == "12 hrs") != -1){
        var default_index = this.acqusitionRates.findIndex(x => x.acqusitionRateLabel == "12 hrs")
        this.$store.state.acqusitionRate = this.acqusitionRates[default_index].id
        this.selectedAcqusitionRateLabel = this.acqusitionRates[default_index].acqusitionRateLabel
        this.acqusitionRate = this.acqusitionRates[default_index].id
        this.getOperatingConditions()
      }
      return instrumentTypes[instrument_index].AcqusitionRate;
    },
    getOperatingConditions(){
      if(this.ambientTemperatureType == 1){
        var index = this.updateRates.findIndex(x => x.id === this.updateRate);
        this.operatingConditions = this.updateRates[index].operratingConditions
        this.getOperatingConditionValue()
      }else if(this.ambientTemperatureType == 0){
        var index = this.updateRates.findIndex(x => x.id === this.updateRate);
        this.operatingConditions = this.updateRates[index].operratingConditions
        this.getOperatingConditionValue()
      }else if(this.ambientTemperatureType == 2){
        var index = this.updateRates.findIndex(x => x.id === this.updateRate);
        this.operatingConditions = this.updateRates[index].operratingConditions
        this.getOperatingConditionValue()
      }else if(this.ambientTemperatureType == 3){
        var index = this.acqusitionRates.findIndex(x => x.id === this.acqusitionRate)
        this.operatingConditions = this.acqusitionRates[index].bodyTemperature[0].values
        this.getOperatingConditionValue()
      }
      
    },

    getOperatingConditionValue(){
      if(this.ambientTemperatureType == 0){
        var index = this.operatingConditions.findIndex(x => x.id === this.operatingCondition);
        if(index != -1){
        this.operatingConditionValue = this.operatingConditions[index].value
        }
      }else if(this.ambientTemperatureType == 1){
        var index = this.operatingConditions.findIndex(x => x.id === this.operatingCondition);
        if(index != -1){
        this.temperatures = this.operatingConditions[index].temperature
        }
      }else if(this.ambientTemperatureType == 2){
        var index = this.operatingConditions.findIndex(x => x.id === this.operatingCondition);
        if(index != -1){
        this.temperatures = this.operatingConditions[index].temperature
        }
      }else if(this.ambientTemperatureType == 3){
        if(this.operatingCondition != ""){}{
            var index = this.operatingConditions.findIndex(x => x.id === this.operatingCondition);
            if(index != -1){
              this.operatingConditionValue = this.operatingConditions[index].value
            }     
        }    
      }
    },
    getAmbientTemperatures(){
      var index = this.powerTypes.findIndex(x => x.id === this.powerType);
      this.ambientTemperatures = this.powerTypes[index].ambiant_temperature
      if(this.powerType == 2){
        this.powerModuleURL = "https://www.emerson.com/en-us/catalog/emerson-701p-blue-smartpower-module"
      }else if(this.powerType == 1){
        this.powerModuleURL = "https://www.emerson.com/en-us/catalog/automation-solutions/emerson-sku-701p-black-smartpower-module"
      }else if(this.powerType == 3){
        this.powerModuleURL = "https://www.emerson.com/en-us/catalog/automation-solutions/emerson-sku-701p-green-smartpower-module"
      }else if(this.powerType == 9){
        this.powerModuleURL = "https://www.emerson.com/en-us/catalog/rosemount-sku-00g45-9000-0001"
      }else if(this.powerType == 7){
        this.powerModuleURL = "https://www.emerson.com/en-us/catalog/industrial-wireless/wireless-spare-parts?fetchFacets=true#facet:-100282111115101109111117110116&partsFacet:&facetLimit:&productBeginIndex:0&partsBeginIndex:0&orderBy:&partsOrderBy:&pageView:grid&minPrice:&maxPrice:&pageSize:&facetRange:&"
      }else if(this.powerType == 8){
        this.powerModuleURL = "https://www.emerson.com/en-us/catalog/automation-solutions/ams-sku-a0702ppu"
      }else{
        this.powerModuleURL = this.$store.state.view_product_result
      }
    },

    getResult(){
      if(this.ambientTemperatureType == 0){
        var result = (this.operatingConditionValue * this.ambientTemperature).toFixed(1)
          if(result >= 10){
            this.result = 10.0 + "+"
          }else{
            this.result =  result
          }
      }else if (this.ambientTemperatureType == 1){
        if(this.temperatures.length != 0){
          var ambient_index = this.ambientTemperatures.findIndex(x => x.value == this.ambientTemperature)
          var result = this.temperatures[ambient_index].value
          if(result >= 10){
            this.result =  10.0 + "+"
          }else{
            this.result =  result
          }
        }else{
          this.result =  0
        }
         
      }else if (this.ambientTemperatureType == 2){
        if(this.temperatures.length != 0){
          var ambient_index = this.ambientTemperatures.findIndex(x => x.value == this.ambientTemperature)
          var result = (this.temperatures[ambient_index].value).toFixed(1)
          if(result >= 10){
            this.result =  10.0 + "+"
          }else{
            this.result =  result
          }
        }else{
          this.result =  0
        }
         
      }else if(this.ambientTemperatureType == 3){
        var result = (this.operatingConditionValue).toFixed(1)
          if(result >= 10){
            this.result =  10.0 + "+"
          }else{
            this.result =  result
          }
      }

    },

    ProductActiveBorder(){
      var border =""
      var color =""
      if(this.productCategory != ""){
        border = "15px solid #00AA7E",
        color="white"
      }else{
        color="#C0C0C0"
        border = "15px solid #101010"
      }
      return {
        borderLeft:border,
        borderRadius:"0px"
      };
    },
    InstrumentTypeActiveBorder(){
      var border =""
      var color =""
      if(this.instrumentType != ""){
        border = "15px solid #00AA7E",
        color="white"
      }else{
        color="#C0C0C0"
        border = "15px solid #101010"
      }
      return {
        borderLeft:border,
        borderRadius:"0px"
      };
    },
    UpdateRateActiveBorder(){
      var border =""
      var color =""
      if(this.updateRate != ""){
        border = "15px solid #00AA7E",
        color="white"
      }else{
        color="#C0C0C0"
         border = "15px solid #101010"
      }
      return {
        borderLeft:border,
        borderRadius:"0px"
      };
    },
    AxquisitionRateActiveBorder(){
      var border =""
      var color =""
      if(this.acqusitionRate != ""){
        border = "15px solid #00AA7E",
        color="white"
      }else{
        color="#C0C0C0"
         border = "15px solid #101010"
      }
      return {
        borderLeft:border,
        borderRadius:"0px"
      };
    },
    PowerTypeActiveBorder(){
      var border =""
      var color =""
      if(this.powerType != ""){
        border = "15px solid #00AA7E",
        color="white"
      }else{
        color="#C0C0C0"
        border = "15px solid #101010"
      }
      return {
        borderLeft:border,
        borderRadius:"0px"
      };
    },
    OperatingTemperatureActiveBorder(){
      var border =""
      var color =""
      if(this.operatingCondition != ""){
        border = "15px solid #00AA7E",
        color="white"
      }else{
        color="#C0C0C0"
        border = "15px solid #101010"
      }
      return {
        borderLeft:border,
        borderRadius:"0px"
      };
    },
    AmbientTemperatureActiveBorder(){
      var border =""
      var color =""
      if(this.ambientTemperature != ""){
        border = "15px solid #00AA7E",
        color="white"
      }else{
        color="#C0C0C0"
         border = "15px solid #101010"
      }
      return {
        borderLeft:border,
        borderRadius:"0px"
      };
    },
    ResultActiveBorder(){
      var border =""
      var color =""
      if(this.result != 0){
        border = "15px solid #00AA7E",
        color="white"
      }else{
        color="#C0C0C0"
        border = "15px solid #101010"
      }
      return {
        borderLeft:border,
        borderRadius:"0px"
      };
    },
    viewProduct(){
      window.open(this.powerModuleURL)
    },
    reset(){
      this.powerType = ""
      this.acqusitionRate = ""
      this.updateRate = ""
      this.instrumentType = ""
      this.ambientTemperature = ""
      this.operatingCondition = ""
      this.selectedAcqusitionRateLabel = ""
      this.selectedAmbientTemperatures = ""
      this.selectedInstrumentType = ""
      this.selectedOperatingCondition = ""
      this.selectedPowerType = ""
      this.selectedUpdateRate = ""
      
    }
  }
}
</script>
<style scoped>
.v-select__slot{
  padding-top: 15px!important;
}
.form-columns{
  text-align: left;
}
.v-list{
  text-align: left!important;
}

.v-expansion-panel--active > .v-expansion-panel-header {
    min-height: 100px;
    border-left: 15px solid #00AA7E;
    border-radius: 0!important;
}
.v-expansion-panel-header {
   min-height: 80px;
}
.v-expansion-panel-content {
    display: flex;
    border-radius: 0!important;
    min-height: 100px;
    padding-top: 5%;
}
</style>
